import { Card, Dropdown, FloatButton, Pagination, Tooltip } from 'antd'
import React from 'react'
import { DownOutlined, PlusOutlined, LeftOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { formateDate } from 'src/components/helpers/formateDate';
import { deleteClientAbonement, getAbonementsClient } from 'src/store/Slices/ClientsSlice';
import { commentsAction } from 'src/store/Slices/ClientsSlice'
import SureModal from 'src/components/Modals/SureModal';
import { useState } from 'react';
import EditAbonement from '../Modals/EditAbonement';
import EditComment from '../Modals/EditComment';
import { flagSet } from '@coreui/icons';

const MobileClientsComments = ({
    getCommentsList,
    getCommentsListLoading,
    setIsOpenAddCommentModal,
    commentInfo,
    setCommentInfo,
    page,
    setPage,
    setPageSize,
    setTab,
    clientInfo,
    mnemo
}) => {

    const dispatch = useDispatch()

    const [openDeliteAbonementModal, setOpenDeliteAbonementModal] = useState(false)
    const [isOpenAddEditModal, setIsOpenEditModal] = useState(false)


    const items = [
        {
            key: '1',
            label: 'Редактировать',
            onClick: () => { setIsOpenEditModal(true) },
            disabled : (!mnemo?.children?.find(el => el.name === 'Таблица абонементов')?.children.find(ele => ele.mnemo === 'updateBtn'))
        },
        {
            key: '3',
            label: 'Удалить',
            onClick: () => { setOpenDeliteAbonementModal(true) },
            disabled : (!mnemo?.children?.find(el => el.name === 'Таблица абонементов')?.children.find(ele => ele.mnemo === 'deleteBtn'))
        },
    ];

    const onClickYesDeleteAbonement = () => {
        dispatch(commentsAction({ flag: 'delete', value: { 
            Id: commentInfo?.id 
        }})).then(() => {
            dispatch(commentsAction({ flag: 'get', value: { UserId: clientInfo?.id }}))
            setOpenDeliteAbonementModal(false)
        })
    }

    return (
        <>
            <SureModal
                visible={openDeliteAbonementModal}
                setVisible={setOpenDeliteAbonementModal}
                onClickYes={onClickYesDeleteAbonement}
            />
            <EditComment
                commentModal={isOpenAddEditModal}
                setCommentModal={setIsOpenEditModal}
                clientInfo={clientInfo}
                commentInfo={commentInfo}
            />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Pagination
                    defaultCurrent={page}
                    pageSize={20}
                    showSizeChanger={false}
                    current={page}
                    onChange={(page, pageSize) => {
                        dispatch(commentsAction({flag: 'get', value: {
                            clientId: clientInfo.id,
                            count: pageSize,
                            offset: pageSize * (page - 1),
                        }}))
                        setPage(page)
                        setPageSize(pageSize)
                    }}
                    total={getCommentsList?.data?.value?.totalCount}
                    page={page}
                />
                {getCommentsList?.data?.value?.rows.map(element => {
                    return (
                        <Card
                            loading={getCommentsListLoading}
                            title={`Комментарий`}
                            extra={<Dropdown
                                menu={{
                                    items,
                                }}
                            >
                                <a onClick={() => {
                                    setCommentInfo(element)
                                }} className="text-primary text-decoration-none">
                                    Действия <DownOutlined />
                                </a>
                            </Dropdown>}
                            style={{ width: 330, marginTop: 16 }}
                            key={element.id}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div>Дата контакта:</div>
                                    <div>Комментарий:</div>
                                    <div>Задача:</div>
                                </div>
                                <div>
                                    <div>{element?.contactDate ? <Tooltip title={element?.contactDate}>{formateDate(element?.contactDate)}</Tooltip> : '-'}</div>
                                    <div>{element?.comment ? <Tooltip title={element?.comment}>{element?.comment.slice(0, 15)}</Tooltip> : '-'}</div>
                                    <div>{element?.task ? <Tooltip title={element?.task}>{element?.task.slice(0, 15)}</Tooltip> : '-'}</div>
                                </div>
                            </div>
                        </Card>
                    )
                })}
                <FloatButton
                    disabled={(!mnemo?.children?.find(el => el.name === 'Таблица абонементов')?.children.find(ele => ele.mnemo === 'insertBtn'))}
                    style={{ right: 24 }}
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        setIsOpenAddCommentModal(true)
                    }}
                />
                <FloatButton
                    style={{ left: 24 }}
                    type="primary"
                    icon={<LeftOutlined />}
                    onClick={() => { setTab('Клиенты') }}
                />
            </div>
        </>
    )
}

export default MobileClientsComments